export const STUDENT_DIRECTORY_PAGE_SIZES = [25, 50, 100];

export type StudentDirectoryFilters = {
  search: string;
  status: string;
  gender: "" | "male" | "female";
  current_class: string;
  residence: "" | "day" | "boarding";
  uses_transport: "" | "true" | "false";
  ordering: keyof typeof STUDENT_ORDERINGS;
};

export const EMPTY_STUDENT_FILTERS: StudentDirectoryFilters = {
  search: "",
  status: "",
  gender: "",
  current_class: "",
  residence: "",
  uses_transport: "",
  ordering: "name",
};

// Every ordering ends on id so paging is stable when names repeat.
export const STUDENT_ORDERINGS = {
  name: ["Name A–Z", "user__first_name,user__last_name,id"],
  "-name": ["Name Z–A", "-user__first_name,-user__last_name,-id"],
  class: [
    "Class",
    "current_class__level,current_class__section,user__first_name,user__last_name,id",
  ],
  student_id: ["Student ID", "student_id,id"],
  newest: ["Newest admission", "-admission_date,-id"],
  oldest: ["Oldest admission", "admission_date,id"],
} as const;

export const STUDENT_STATUS_TABS: [string, string][] = [
  ["", "All"],
  ["active", "Active"],
  ["inactive", "Inactive"],
  ["suspended", "Suspended"],
  ["transferred", "Transferred"],
  ["graduated", "Graduated"],
];

/** The query the student list endpoint expects for these filters. */
export function studentDirectoryParams(filters: StudentDirectoryFilters) {
  const params: {
    search?: string;
    status?: string;
    gender?: string;
    current_class?: number;
    residence?: string;
    uses_transport?: boolean;
    ordering: string;
  } = { ordering: STUDENT_ORDERINGS[filters.ordering][1] };
  const search = filters.search.trim();
  if (search) params.search = search;
  if (filters.status) params.status = filters.status;
  if (filters.gender) params.gender = filters.gender;
  if (filters.current_class) params.current_class = Number(filters.current_class);
  if (filters.residence) params.residence = filters.residence;
  if (filters.uses_transport)
    params.uses_transport = filters.uses_transport === "true";
  return params;
}

/** How many filters narrow the list; sorting only reorders it. */
export function activeStudentFilterCount(filters: StudentDirectoryFilters) {
  return [
    filters.search.trim(),
    filters.status,
    filters.gender,
    filters.current_class,
    filters.residence,
    filters.uses_transport,
  ].filter(Boolean).length;
}
